<template>
  <div v-if="backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="$event.target.classList.contains('modal') ? close() : true"
    >
      <div class="modal-dialog modal-dialog-centered modal-ku" role="document">
        <div class="modal-content" style="width: 800px">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ config.title == null ? "&nbsp;" : config.title }}
            </h5>
            <button
              type="button"
              class="close"
              @click="close()"
              v-html="loading ? spin() : ic('close')"
            />
          </div>

          <!-- <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
          <Nodata v-if="!loading && _user_rekenings.length == 0"/>  -->
          <!-- v-if="!loading && user_rekenings.length > 0" -->
          <section class="box m-3">
            <div class="card">
              <div class="table-responsive">
                <table
                  class="table table-vcenter table-hover card-table table-striped table-control"
                >
                  <thead>
                    <tr class="text-muted">
                      <th>No</th>
                      <th>Nama Bank</th>
                      <th>Cabang Bank</th>
                      <th>Nomor Rekening</th>
                      <th>Nama Pemilik Rekening</th>
                      <th>Active</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(user_rekening, index) in user_rekenings"
                      :key="user_rekening.id"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ user_rekening.nama_bank }}</td>
                      <td>{{ user_rekening.cabang_bank }}</td>
                      <td>{{ user_rekening.nomor_rekening }}</td>
                      <td>{{ user_rekening.nama_pemilik_rekening }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="
                            user_rekening.is_active
                              ? 'bg-success'
                              : 'bg-secondary'
                          "
                          >{{
                            user_rekening.is_active ? "Active" : "Non Active"
                          }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group">
                          <button
                            class="btn btn-white btn-sm"
                            :disabled="loading"
                            @click="_edit(user_rekening)"
                            v-html="ic('edit')"
                          ></button>
                          <button
                            class="btn btn-white btn-sm text-danger"
                            :disabled="loading"
                            @click="_deleteRekening(user_rekening.id)"
                            v-html="ic('trash')"
                          ></button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-0">
                        <button
                          v-if="!form.is_edit"
                          class="btn"
                          @click="_reset()"
                          v-html="ic('refresh')"
                        />
                        <div class="text-center" v-else>
                          {{ user_rekening.id }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model="user_rekening.nama_bank"
                          placeholder="Nama Bank"
                          class="form-control"
                        />
                      </td>
                      <td>
                        <input
                          v-model="user_rekening.cabang_bank"
                          placeholder="Cabang Bank"
                          class="form-control"
                        />
                      </td>
                      <td>
                        <input
                          v-model="user_rekening.nomor_rekening"
                          placeholder="Nomor Rekening"
                          class="form-control"
                        />
                      </td>
                      <td>
                        <input
                          v-model="user_rekening.nama_pemilik_rekening"
                          placeholder="Nama Pemilik Rekening"
                          class="form-control"
                        />
                      </td>
                      <td>
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="is_active"
                            v-model="user_rekening.is_active"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="btn-group p-0">
                          <button
                            class="btn btn-sm"
                            :disabled="loading"
                            @click="
                              form.is_edit ? _updateRekening() : _saveRekening()
                            "
                            v-html="ic('save')"
                          ></button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
  name: "ModalUserRekening",
  props: {
    config: {
      default: {
        view: false,
        title: "Modal Title",
      },
    },
    user_id: "",
  },

  mixins: [helper],

  data() {
    return {
      backdrop: false,
      modal: {
        open: false,
      },
      loading: false,
      form: {
        is_edit: false,
      },
      user_rekening: {
        id: "",
        id_user: "",
        nama_bank: "",
        nomor_rekening: "",
        nama_pemilik_rekening: "",
        cabang_bank: "",
        is_active: true,
      },
    };
  },
  computed: {
    ...mapState("user_rekening", {
      user_rekenings: (state) => state.datas,
    }),
  },
  methods: {
    ...mapActions("user_rekening", [
      "listUserRekening",
      "storeUserRekening",
      "updateUserRekening",
      "deleteUserRekening",
    ]),

    _edit(user_rekening) {
      this.form.is_edit = true;
      this.user_rekening.id = user_rekening.id;
      this.user_rekening.id_user = user_rekening.id_user;
      this.user_rekening.nama_bank = user_rekening.nama_bank;
      this.user_rekening.nomor_rekening = user_rekening.nomor_rekening;
      this.user_rekening.nama_pemilik_rekening =
        user_rekening.nama_pemilik_rekening;
      this.user_rekening.cabang_bank = user_rekening.cabang_bank;
      this.user_rekening.is_active = user_rekening.is_active;
    },
    async _updateRekening() {
      try {
        const res = await this.updateUserRekening(
          this.user_rekening
        );
        if (res) {
          this._reset();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async _saveRekening() {
      try {
        const res = await this.storeUserRekening(
          this.user_rekening
        );
        if (res) {
          this._reset();
        }
      } catch (error) {
        console.log(error);
      }
    },
    _deleteRekening(id) {
      this.$swal({
        title: "Kamu Yakin?",
        text: "ingin menghapus data rekening ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Iya, Lanjutkan!",
      }).then((result) => {
        if (result.value) {
          this.deleteUserRekening(id);
        }
      });
    },

    _getRekening() {
      this.loading = true;
      this.listUserRekening({ id_user: this.user_rekening.id_user });
      this.loading = false;
    },

    _reset() {
      this.form.is_edit = false;
      this.user_rekening.id = "";
      this.user_rekening.nama_bank = "";
      this.user_rekening.nomor_rekening = "";
      this.user_rekening.nama_pemilik_rekening = "";
      this.user_rekening.cabang_bank = "";
      this.user_rekening.is_active = true;
    },

    close() {
      this.$emit("update:config", { view: false });
    },
  },

  watch: {
    "config.view": function (view) {
      if (view) {
        this.backdrop = true;
        setTimeout(() => {
          this.modal.open = view;
        }, 100);
      } else {
        this.modal.open = view;
        setTimeout(() => {
          this.backdrop = view;
        }, 100);
      }
    },
    user_id: function (user_id) {
      this.user_rekening.id_user = user_id;
      this._getRekening();
    },
  },
};
</script>
<style scoped>
.modal-dialog {
  min-width: 850px;
}
</style>
